import MainLayout from "Layouts/Main";
import { useState, useEffect } from "react";
import { useNavigate, NavLink, Outlet, useParams } from "react-router-dom";
import assets from "Assets";
import './styles.scss';

//components
import Button from "Components/Button";
import DetailsCard from "Components/Common/DetailsCard";
import Modal from "Components/Common/Modal";
import InputBox from "Components/InputBox";
import DatePicker from "Components/Common/DatePicker";


//redux
import { useDispatch } from "react-redux";
import { fetchIndividualCompany, addCredit } from "../../../../Redux/Slices/companyManagementSlice";
import { notifySuccess } from "Services/Utils/toastNotification";


function ViewCompany() {

    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [companyData, setCompanyData] = useState({}) 
    const [credit, setCredit] = useState("")
    const [expiryDate, setExpiryDate] = useState("");
    const [modal, setModal] = useState(false);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [triggerRerender, setTriggerRerender] = useState(false)
    const requestNavLinks = [
        {
            to: "companyInfo",
            label: "Company Info",
            id: "1",
        },
        {
            to: "purchaseHistory",
            label: "Purchase History",
            id: "2",
        },
        {
            to: "manageUsers", 
            label: "Manage Users",
            id: "3",
        },
        {
            to: "noOfUsers", 
            label: "No. Of Users",
            id: "4",
        },
        {
            to: "subscriptions", 
            label: "Subscriptions",
            id: "5",
        },
        {
            to: "serviceHistory", 
            label: "Service History",
            id: "6",
        },
    ];
    
    useEffect(()=>{
        dispatch(
            fetchIndividualCompany({
                data:{id},
                callBack: getCompanyCB,
            })
        )
    },[triggerRerender])
    const getCompanyCB = (value)=>{
        // console.log(value);
        setCompanyData(value?.result[0])
    }

    const formatDateToLocal = (dateString) => {
      const date = new Date(dateString);
    
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
    
      return `${year}-${month}-${day}`;
    };

    const addCompanyCredit = () => {
      // console.log(formatDateToLocal(expiryDate))
      const addCreditCB = () => {
        setTriggerRerender(!triggerRerender)
        setExpiryDate("")
        setCredit("")
        setModalConfirm(false)
        notifySuccess("Credits Added Successfully")
      }
      dispatch(
        addCredit({
          data: {
            company_id: id,
            no_of_credit: credit,
            valid_date: formatDateToLocal(expiryDate),
          },
          callBack:addCreditCB,
        })
      );
    }
    const handleFromDate = (date) => {
        setExpiryDate(new Date(date));
      };

    return (
      <MainLayout pageName={"Company Management"}>
        <div
          className="goBackDiv"
          onClick={() => navigate("/companyManagement")}
        >
          {" "}
          {/* Fixed the path */}
          <img src={assets.Icons.leftArrow} alt="backIcon" />
          <p>Back to Companies List</p>
        </div>
        <div className="viewCompanyContainer">
          <div className="viewCompanyHeader">
            <p>{companyData?.company_name} Company</p>
            <div className="addCreditsButton">
              <Button
                buttonStyle={{ height: "2vh" }}
                title="Add Credits"
                onClick={() => {
                  setModal(true);
                }}
              />
            </div>
          </div>
          <div className="cardContainers">
            <DetailsCard
              image={assets.Icons.noOfCompanies}
              info={companyData?.user_count}
              title="Total No.of Users"
              color="#22448F"
            />
            <DetailsCard
              image={assets.Icons.activeUsersIcon}
              info={companyData?.active_users}
              title="Active Users"
              color="#4CC5C9"
            />
            <DetailsCard
              image={assets.Icons.inActiveUsers}
              info={companyData?.in_active_users}
              title="Inactive Users"
              color="#E84F44"
            />
            <DetailsCard
              image={assets.Icons.creditsLogo}
              info={companyData?.no_of_credit}
              title="Available Credits"
              color="#5E98D7"
            />
          </div>
          <div className="viewCompanyNavBar">
            {requestNavLinks.map((option) => (
              <div key={option.id} className="viewCompanyOptionContainer">
                <NavLink
                  key={option.id}
                  to={option.to}
                  style={{ textDecoration: "none" }}
                  className={({ isActive }) =>
                    isActive
                      ? "active-viewCompanyOptionContainerNav"
                      : "viewCompanyOptionContainerNav"
                  }
                >
                  {option.label}
                </NavLink>
              </div>
            ))}
          </div>
          <br></br>
          <Outlet /> {/* Renders child route components */}
        </div>
        <Modal
          open={modal}
          closeModal={() => {
            setModal(false);
          }}
        >
          <div className="mapExistingUser">
            <h4>Add credits to {companyData?.company_name} </h4>
            <div className="mapExistingUserDropdownContainer">
              <p>No of Credits</p>
              <div className="AddCompanyInputBoxContainer">
                <InputBox
                  inputStyle={{
                    boxShadow: "none",
                    border: "1px solid #B2BEC3",
                    padding: "1px 2vh 1px 2vh",
                    height: "7vh",
                  }}
                  name="companyName"
                  value={credit}
                  onChange={(e) => setCredit(e.target.value)}
                  type="number"
                />
              </div>
            </div>
            <div className="mapExistingUserDropdownContainer">
              <p>Valid Till</p>
              <div className="AddCompanyInputBoxContainer">
                <DatePicker
                  placeholderText="DD-MM-YYYY"
                  selected={expiryDate}
                  onChange={handleFromDate}
                  minDate={new Date()}
                  format={"dd-MM-yyyy"}
                  border={true} 
                  width = '24vw'
                  height = '7vh'
                  radius = '6px'
                />
              </div>
            </div>
            <div className="mapExistingUserButtonsContainer">
              <div className="mapExistingUserButtonContainer">
                <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => {setCredit(""); setExpiryDate(""); setModal(false)}}
                />
              </div>
              <div className="mapExistingUserButtonContainer">
                <Button 
                  buttonStyle={{ height: "2vh" }} 
                  title="Add" 
                  onClick={() => {setModal(false); setModalConfirm(true);}}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={modalConfirm}
          closeModal={() => {
            setModalConfirm(false);
          }}
        >
          <div className="mapExistingUser">
            <h4 style={{textAlign:"center"}}>Are you sure you want to add {credit} credits to <br />{companyData?.company_name || 'Company'}</h4>
            <div className="mapExistingUserButtonsContainer">
              <div className="mapExistingUserButtonContainer">
                <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={()=>setModalConfirm(false)}
                />
              </div>
              <div className="mapExistingUserButtonContainer">
                <Button buttonStyle={{ height: "2vh" }} title="Yes, Add" onClick={addCompanyCredit}/>
              </div>
            </div>
          </div>
        </Modal>
      </MainLayout>
    );
}

export default ViewCompany;
